module.exports = __webpack_public_path__ + "media/maps-markers/purple-pin-6af7f56d.svg";